import i18next from 'i18next';
import React, { useCallback } from 'react';
import { makeStyles } from 'tss-react/mui';
import { translate, translateToHTML } from '../../../base/i18n/functions';
import Dialog from '../../../base/ui/components/web/Dialog';
import { toggleLanguageSelectorDialog } from '../../actions.web';
import AbstractLanguageSelectorDialog from '../AbstractLanguageSelectorDialog';
import LanguageList from './LanguageList';
const useStyles = makeStyles()(theme => {
    return {
        paragraphWrapper: {
            fontSize: '0.875rem',
            margin: '10px 0px',
            color: theme.palette.text01
        }
    };
});
const LanguageSelectorDialog = (props) => {
    const { dispatch, language, listItems, onLanguageSelected, subtitles, t } = props;
    const { classes: styles } = useStyles();
    const onSelected = useCallback((e) => {
        onLanguageSelected(e);
        dispatch(toggleLanguageSelectorDialog());
    }, [language]);
    return (React.createElement(Dialog, { cancel: { hidden: true }, ok: { hidden: true }, titleKey: 'transcribing.subtitles' },
        React.createElement("p", { className: styles.paragraphWrapper }, translateToHTML(t, 'transcribing.sourceLanguageDesc', {
            'sourceLanguage': t(`languages:${i18next.language}`).toLowerCase()
        })),
        React.createElement(LanguageList, { items: listItems, onLanguageSelected: onSelected, selectedLanguage: subtitles })));
};
/*
 * We apply AbstractLanguageSelector to fill in the AbstractProps common
 * to both the web and native implementations.
 */
// eslint-disable-next-line new-cap
export default translate(AbstractLanguageSelectorDialog(LanguageSelectorDialog));
